import React, { useEffect, useState } from 'react'
import { Button, Dimmer, Divider, Grid, Icon, Input, List, Loader } from 'semantic-ui-react'
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createCamera, deleteCamera, loadCameras, updateCamera } from '../actions/cameras'
import EmptyCamera from './EmptyCamera'
import WebcamForm from './WebcamForm'
import styles from './styles.css'

const WebCamManager = ({ geoCategoryId }) => {
  const { path, url } = useRouteMatch()
  const { cameras, isLoading } = useSelector(state => {
    if (geoCategoryId) {
      return {
        cameras: state.cameras.cameras.filter(camera => camera.categories.includes(geoCategoryId)),
        isLoading: state.cameras.isLoading,
      }
    } else {
      return state.cameras
    }
  })
  const dispatch = useDispatch()
  const [searchString, setSearchString] = useState('')
  useEffect(() => {
    const query = {}
    if (searchString) {
      query.search_string = searchString
    }
    if (geoCategoryId) {
      query.category = geoCategoryId
    }
    dispatch(loadCameras(query))
  }, [dispatch, searchString])

  let cameraList
  if (isLoading) {
    cameraList = (
      <Dimmer active inverted>
        <Loader/>
      </Dimmer>
    )
  } else if (cameras.length) {
    let cameraListItems = cameras.map(camera => <List.Item key={camera._id}>
      <List.Content as={NavLink} to={`${url}/${camera._id}`} activeClassName={styles.activeCamera}>
        {camera.locales.EN.name}
      </List.Content>
    </List.Item>
    )
    cameraList = (
      <List size='large' style={{ height: '100%', overflowY: 'scroll' }}>
        {cameraListItems}
      </List>
    )
  } else {
    cameraList = 'Нет камер'
  }

  return <Grid divided style={{ height: '100%' }}>
    <Grid.Column width={3}>
      <Button as={NavLink} to={`${url}/new`} basic fluid color='blue'>
        <Icon name='plus'/>
        Добавить камеру
      </Button>
      <Divider/>
      <Input disabled={!cameras.length && !searchString} fluid placeholder='Поиск...'
        onChange={(event, data) => setSearchString(data.value)}/>
      <Divider/>
      <div style={{ height: 'calc(100% - 150px)' }}>
        {cameraList}
      </div>
    </Grid.Column>
    <Grid.Column width={13}>
      <Switch>
        <Route exact path={path}>
          <EmptyCamera/>
        </Route>
        <Route path={`${path}/new`} render={() =>
          <WebcamForm
            initialData={null}
            cameraId={null}
            geoCategoryId={geoCategoryId || null}
            onSubmit={(data) => dispatch(createCamera(data))}
          />
        }/>
        <Route path={`${path}/:cameraId`} render={({ match }) => {
          const cameraId = match.params.cameraId
          let selectedCamera = cameras.find(camera => camera._id === Number(cameraId))
          return <WebcamForm
            initialData={selectedCamera}
            cameraId={cameraId}
            geoCategoryId={geoCategoryId || null}
            onSubmit={(data) => dispatch(updateCamera(selectedCamera._id, data))}
            onDelete={(cameraId) => dispatch(deleteCamera(cameraId))}
          />
        }}/>
      </Switch>
    </Grid.Column>
  </Grid>
}

export default WebCamManager
